export default {
      id: "ar_mine-usage",
      viewBox: "0 0 110 100",
      url: "../dist/images/" + "sprite.svg#ar_mine-usage",
      toString: function () {
        return this.url;
      }
    }